import type { WalletUBOInfosType, UpdateUBOBodyType } from '@/types';

export const useWalletInformationStore = defineStore('wallet-information', {
  state: () => ({
    walletUBOs: [] as WalletUBOInfosType[],
    selectedUBOToUpdate: undefined as WalletUBOInfosType | undefined,
    CityOfBirth: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    CountryOfBirth: undefined as string | undefined,
    CountryOfResidence: undefined as string | undefined,
    DateOfBirth: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    FirstName: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    LastName: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    Nationality: [] as Array<string>,
    Password: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    Id: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    StartDate: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    EndDate: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    IsActive: false as boolean,
    selectedUBOIndex: 0 as number,
    isCardBeingEdited: false as boolean
  }),
  getters: {
    getUpdateUBOBody(): UpdateUBOBodyType {
      return {
        CityOfBirth: this.CityOfBirth.value,
        CountryOfBirth: this.CountryOfBirth,
        CountryOfResidence: this.CountryOfResidence,
        DateOfBirth: this.DateOfBirth.value,
        FirstName: this.FirstName.value,
        LastName: this.LastName.value,
        Nationality: this.Nationality.join(','),
        Password: this.Password.value,
        IsActive: this.IsActive
      };
    }
  },
  actions: {
    init() {
      this.CityOfBirth = {
        value: this.selectedUBOToUpdate?.CityOfBirth,
        isValid: !!this.selectedUBOToUpdate?.CityOfBirth
      };
      this.CountryOfBirth = this.selectedUBOToUpdate?.CountryOfBirth;
      this.CountryOfResidence = this.selectedUBOToUpdate?.CountryOfResidence;
      this.DateOfBirth = {
        value: this.selectedUBOToUpdate?.DateOfBirth,
        isValid: !!this.selectedUBOToUpdate?.DateOfBirth
      };
      this.FirstName = {
        value: this.selectedUBOToUpdate?.Firstname,
        isValid: !!this.selectedUBOToUpdate?.Firstname
      };
      this.LastName = {
        value: this.selectedUBOToUpdate?.Lastname,
        isValid: !!this.selectedUBOToUpdate?.Lastname
      };
      this.Nationality = this.selectedUBOToUpdate?.Nationality
        ? this.selectedUBOToUpdate?.Nationality?.split(',')
        : [];
      this.IsActive = !this.selectedUBOToUpdate?.EndDate;
      this.Id = {
        value: this.selectedUBOToUpdate?.Id.toString(),
        isValid: !!this.selectedUBOToUpdate?.Id
      };
      this.StartDate = {
        value: this.selectedUBOToUpdate?.StartDate.split(' ')[0],
        isValid: !!this.selectedUBOToUpdate?.StartDate
      };
      this.EndDate = {
        value: this.selectedUBOToUpdate?.EndDate?.split(' ')[0],
        isValid: !!this.selectedUBOToUpdate?.EndDate
      };
    }
  }
});
